import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { clearSpecificationsAction, getSpecificationsActions } from '../../redux/actions/specificationsActions';

const useFetchSpecifications = () => {
  const dispatch = useDispatch();
  const loading = useSelector((state) => state.specifications.loading);
  const specifications = useSelector((state) => state.specifications);

  const fetchSpecifications = useCallback(async () => {
    await dispatch(getSpecificationsActions());
  }, [dispatch]);

  useEffect(() => {
    fetchSpecifications();
  }, [fetchSpecifications]);

  useEffect(() => {
    return () => {
      dispatch(clearSpecificationsAction());
    };
  }, [dispatch]);

  return { loading, specifications };
};

export default useFetchSpecifications;
